import { getElementSize } from '../utils/sizes';
import { ITEMS_BY_BREAKPOINTS } from './customer/default/portrait.constants';

export * from './customer/default/portrait.constants';

export const templates = {
  Portrait: 'Portrait',
};

const RATIO = 3 / 2;

const { sizes, imageOptions } = getElementSize(ITEMS_BY_BREAKPOINTS, RATIO, templates.Portrait);
export { sizes, imageOptions };
